module.exports = __webpack_public_path__ + "img/vk.8e9ac5f.svg";